// Scripts for single product detail page
import '../css/modules/signature-catalogue-cards.css';
import '../css/modules/product-image-lightbox.css';

// Each webpack entry has its own copy of the stardust client — initialise it
// here (like collection.js does) so modules in this bundle can build routes
import { initRoutes } from '@eidellev/adonis-stardust/client';
initRoutes();

// Sticky buy and drop-a-hint need to come before gallery because they listen to "product:image-change" emitted by gallery
import './modules/product/sticky-buy';
import './modules/product/drop-a-hint';
import './modules/product/gallery';
import './modules/product/image-zoom';
import './modules/product/image-lightbox';
import './modules/accordion';
import './modules/product/analytics';
import './modules/product/affirm';
import './modules/product/sticky-affirm';
import './modules/product/title-swatches';
import './modules/product/straps-options';
